import { Modal } from 'bootstrap';

import { routes } from '@/shared/routes';

import { DELETE, POST } from '@/front/fetch';

const showApiKeySecretModal = (secret: string) => {
  const modalElement = document.getElementById('modal')!;
  const dialog = modalElement.querySelector('.modal-dialog')!;
  const title = modalElement.querySelector('.modal-title')!;
  const body = modalElement.querySelector('.modal-body')!;
  const footer = modalElement.querySelector('.modal-footer')!;

  const modal = new Modal(modalElement);

  dialog.classList.remove('modal-fullscreen');
  title.textContent = 'API Key Created';
  body.innerHTML = `<p class="text-muted">Please copy your API key now and store it securely. For security reasons, this is the only time it will be displayed.</p><pre class="user-select-all bg-light p-3 rounded mb-0">${secret}</pre>`;

  const copyButton = document.createElement('button');
  copyButton.type = 'button';
  copyButton.textContent = 'Copy';
  copyButton.className = 'btn btn-primary';

  const closeButton = document.createElement('button');
  closeButton.type = 'button';
  closeButton.textContent = 'Close';
  closeButton.className = 'btn btn-secondary';

  copyButton.addEventListener('click', async () => {
    await navigator.clipboard.writeText(secret);
    copyButton.textContent = 'Copied';
  });

  closeButton.addEventListener('click', () => modal.hide(), { once: true });

  footer.classList.remove('d-none');
  footer.replaceChildren(copyButton, closeButton);

  modal.show();
};

const replaceRowHtml = (row: Element, rowHtml: string) => {
  const container = document.createElement('div');
  container.innerHTML = rowHtml;
  const newRow = container.firstElementChild;

  if (newRow) {
    row.replaceWith(newRow);
  }
};

export const createApiKey = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const res = await POST(routes.account.apiKeys.create(), {});

  if (res.ok) {
    const { secret, rowHtml } = await res.json();
    const card = button.closest('[data-api-keys-card]');
    const list = card?.querySelector('.table-like');

    if (list) {
      list.querySelector('[data-api-keys-empty]')?.remove();
      list.insertAdjacentHTML('afterbegin', rowHtml);
    }

    showApiKeySecretModal(secret);
  }
};

export const revokeApiKey = async (button: HTMLAnchorElement | HTMLButtonElement) => {
  const keyId = button.dataset.value;

  if (!keyId) {
    return;
  }

  const res = await DELETE(routes.account.apiKeys.revoke({ keyId }));

  if (res.ok) {
    const row = button.closest('.table-like-row');

    if (row) {
      replaceRowHtml(row, await res.text());
    }
  }
};
